export const workEnvironment = {
  junior: {
    macos: [
      { step: 'Install Xcode', command: 'Download from Mac App Store or https://developer.apple.com/xcode/' },
      { step: 'Install Homebrew', command: '/bin/bash -c "$(curl -fsSL https://raw.githubusercontent.com/Homebrew/install/HEAD/install.sh)"' },
      { step: 'Install Node.js', command: 'brew install node' },
      { step: 'Install React Native CLI', command: 'npm install -g @react-native-community/cli' },
      { step: 'Install CocoaPods', command: 'sudo gem install cocoapods' },
      { step: 'Install iOS Simulator', command: 'Open Xcode -> Preferences -> Components -> Install iOS Simulators' }
    ],
    windows: [
      { step: 'Install Android Studio', command: 'Download from https://developer.android.com/studio' },
      { step: 'Install Node.js', command: 'Download from https://nodejs.org and run installer' },
      { step: 'Install Java Development Kit', command: 'Download OpenJDK 11 from https://adoptopenjdk.net/' },
      { step: 'Install React Native CLI', command: 'npm install -g @react-native-community/cli' },
      { step: 'Install Flutter', command: 'Download Flutter SDK from https://docs.flutter.dev/get-started/install/windows' },
      { step: 'Configure Android SDK', command: 'Open Android Studio -> SDK Manager -> Install Android SDK' }
    ],
    linux: [
      { step: 'Install Android Studio', command: 'sudo snap install android-studio --classic' },
      { step: 'Install Node.js', command: 'curl -fsSL https://deb.nodesource.com/setup_lts.x | sudo -E bash - && sudo apt-get install -y nodejs' },
      { step: 'Install Java Development Kit', command: 'sudo apt install openjdk-11-jdk' },
      { step: 'Install React Native CLI', command: 'npm install -g @react-native-community/cli' },
      { step: 'Install Flutter', command: 'sudo snap install flutter --classic' },
      { step: 'Configure Android SDK', command: 'export ANDROID_HOME=$HOME/Android/Sdk && export PATH=$PATH:$ANDROID_HOME/emulator:$ANDROID_HOME/tools:$ANDROID_HOME/tools/bin:$ANDROID_HOME/platform-tools' }
    ]
  },
  mid: {
    macos: [
      { step: 'Install Fastlane', command: 'sudo gem install fastlane' },
      { step: 'Install Firebase CLI', command: 'npm install -g firebase-tools' },
      { step: 'Install Flipper', command: 'brew install --cask flipper' },
      { step: 'Install Charles Proxy', command: 'brew install --cask charles' },
      { step: 'Install TestFlight', command: 'Available on Mac App Store' }
    ],
    windows: [
      { step: 'Install Gradle', command: 'choco install gradle' },
      { step: 'Install Firebase CLI', command: 'npm install -g firebase-tools' },
      { step: 'Install Android Debug Bridge', command: 'Included with Android Studio SDK' },
      { step: 'Install Genymotion', command: 'Download from https://www.genymotion.com/' },
      { step: 'Install Visual Studio Code', command: 'choco install vscode' }
    ],
    linux: [
      { step: 'Install Gradle', command: 'sudo apt install gradle' },
      { step: 'Install Firebase CLI', command: 'npm install -g firebase-tools' },
      { step: 'Install ADB', command: 'sudo apt install android-tools-adb' },
      { step: 'Install Genymotion', command: 'Download .bin file from https://www.genymotion.com/' },
      { step: 'Install VS Code', command: 'sudo snap install code --classic' }
    ]
  },
  senior: {
    macos: [
      { step: 'Install App Store Connect API Tools', command: 'pip3 install appstoreconnect' },
      { step: 'Install Mobile Device Management', command: 'Configure Apple Configurator 2' },
      { step: 'Install Performance Monitoring', command: 'Configure Xcode Instruments' },
      { step: 'Install Security Analysis Tools', command: 'brew install --cask hopper-disassembler' }
    ],
    windows: [
      { step: 'Install Google Play Console Tools', command: 'Configure Google Play Console API' },
      { step: 'Install Enterprise Mobile Management', command: 'Configure Microsoft Intune' },
      { step: 'Install Performance Profiling', command: 'Configure Android Studio Profiler' },
      { step: 'Install Security Testing Tools', command: 'Install OWASP Mobile Security Testing Guide tools' }
    ],
    linux: [
      { step: 'Install CI/CD Tools', command: 'docker pull cimg/android:2023.08' },
      { step: 'Install Mobile Testing Framework', command: 'npm install -g appium' },
      { step: 'Install Performance Monitoring', command: 'Configure Firebase Performance Monitoring' },
      { step: 'Install Security Scanning', command: 'docker pull owasp/mobsf' }
    ]
  }
};
